import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import License from './License';


class Licences extends React.Component {

    state = {
        licencias: []
    }

    static getDerivedStateFromProps(props, state) {
        const { licencias } = props;
        if (licencias !== state.licencias) {
            state.licencias = licencias;
            return state;
        }
        return null;
    }

    onChange = ( id, license ) => {
        const { licencias } = this.state;
        const index = licencias.map((l) => l.id).indexOf(id);
        if(index >= 0) {
            licencias[index] = license;
        }
        this.setState({licencias: licencias});
        const e = {
            target : {
                name: 'licencias',
                value: licencias
            }
        }
        this.props.onChange(e);
    }

    render() {
        const { licencias } = this.state;
        console.log("render licencias")
        return (
            <div className="flex_full_column margin_top_32 ">
                <div className="flex_full_row">
                    <div className="flex_full_row c_dark_grey_blue barlow_semibold">
                        <FormattedMessage id="form_field_name_licenses" />
                    </div>
                </div>
                <div className="flex_full_row wrap margin_top_24">
                    {licencias &&
                        licencias
                            .sort((a, b) => a.id > b.id ? 1 : -1)
                            .map((l) =>
                                <div key={l.id+"_licencia"} className="flex_50 padding_left_6 padding_right_6">
                                    <License {...this.props} licencia={l} onChange={this.onChange} />
                                </div>
                            )
                    }
                </div>
            </div>
        )
    }
}

export default Licences;


// WEBPACK FOOTER //
// ./src/components/complex/manage/customer/Licenses.js